import React, { ChangeEventHandler, useState } from "react";
import "./styles.less";
type Props = {
	name: string;
	id: string;
	placeholder: string;
	className?: string;
	required?: boolean;
	onChange?: ChangeEventHandler<HTMLInputElement>;
	value?: string;
	defaultValue?: string;
};

const DinamicInputText = (props: Props) => {
	return (
		<div className={`dinamicInputText ${props.className}`}>
			<input
				className="dinamicInput"
				defaultValue={props.defaultValue}
				value={props.value}
				onChange={props.onChange}
				id={props.id}
				name={props.name}
				type="text"
				placeholder=" "
				required={props.required}
			/>
			<label htmlFor={props.id}>
				{props.placeholder}
				{props.required ? " *" : ""}
			</label>
		</div>
	);
};

export const TextAreaDinamicInput = (props: Props) => {
	const [value, setValue] = useState<string>("");
	const [active, setActive] = useState<boolean>(false);

	return (
		<div
			className={`dinamicTextArea ${props.className} ${
				active ? "dinamicTextArea--active" : ""
			}`}>
			<p
				className={`dinamicTextArea__header ${
					active || value !== "" ? "dinamicTextArea__header--active" : ""
				}`}>
				{props.placeholder}
				{props.required ? " *" : ""}
			</p>
			<textarea
				className="dinamicTextArea__input"
				onChange={e => setValue(e.target.value)}
				defaultValue={props.defaultValue}
				value={props.value}
				id={props.id}
				onFocus={() => setActive(true)}
				onBlur={() => setActive(false)}
				name={props.name}
				placeholder=" "
				required={props.required}
			/>
		</div>
	);
};

export default DinamicInputText;

